import request from '@/utils/request'

export function giftBagList () {
  return request({
    method: 'get',
    params: {
      do: 'giftBagList'
    }
  })
}

export function getGiftBag (params) {
  return request({
    method: 'get',
    params: {
      do: 'getGiftBag',
      ...params
    }
  })
}
